module.exports = __webpack_public_path__ + "assets/milk-bottle-max.5bcb958d.svg";